<!-- Begin page content -->
<app-block-ui-wrapper [blockUIName]="'cart-section'" #blockUIWrapper>
<div class="main container" *ngIf="cartOn">
   <div class="page-header">
      <h1>Cart</h1>
   </div>
   <table class="table table-condensed">
      <thead>
         <tr>
            <th></th>
            <th>Document</th>
            <th>Total</th>
         </tr>
      </thead>
      <tbody>
         <tr *ngFor="let cartProduct of cart | keyvalue">
            <td style="width:40px">
                <button (click)="expandedKeys = expandedKeys === cartProduct.key ? null : cartProduct.key" 
                        class="btn btn-primary btn-xs">
                    <span [ngClass]="{ 'glyphicon-plus': expandedKeys !== cartProduct.key, 
                                      'glyphicon-minus': expandedKeys === cartProduct.key }" 
                          class="glyphicon">
                    </span>
                </button>
            </td>
            <td> 
                {{ cartProduct.value.title }} - {{ cartProduct.value.pages.length }} Page(s)
                <table class="table" *ngIf="expandedKeys === cartProduct.key">
                  <tbody>
                      <tr class="hidden-xs" *ngFor="let page of cartProduct.value.pages">
                          <td>
                              <img (click)="showPage(page.key)" class="pointMe cartThumbnail" 
                                   [src]="page._thumbs" [zoomImage]="page._overview">
                          </td>
                          <td>{{ page.title }}</td>
                          <td>{{ page.amount | currency:'USD' }}</td>
                          <td>
                              <button (click)="removePage(page.key)" class="btn btn-danger btn-xs">
                                  <span class="glyphicon glyphicon-remove"></span>
                              </button>
                          </td>
                      </tr>
                      <tr class="visible-xs" *ngFor="let page of cartProduct.value.pages">
                          <td>
                            <div class="text-right">
                                <button (click)="removePage(page.key)" class="btn btn-danger btn-xs">
                                    <span class="glyphicon glyphicon-remove"></span>
                                </button>
                            </div>
                            <div class="text-center">
                                <img (click)="showPage(page.key)" class="pointMe cartThumbnail" 
                                     [src]="page._thumbs">
                            </div>
                            <div class="text-center">{{ page.title }}</div>
                            <div class="text-center">{{ page.amount | currency:'USD' }}</div>
                          </td>
                      </tr>
                  </tbody>
                </table>
            </td>
            <td>{{ cartProduct.value.amount | currency:'USD' }}</td>
            <td style="width:40px">
                <button (click)="removeDocument(cartProduct.key)" class="btn btn-danger btn-xs">
                    <span class="glyphicon glyphicon-remove"></span>
                </button>
            </td>
         </tr>
         <tr *ngIf="cartCount === 0">
            <td colspan="3" style="font-weight:bold;text-align:center;">Your Cart Is Empty</td>
         </tr>
         <tr>
            <td colspan="2" style="text-align:right;font-weight:bold;">Total :</td>
            <td>{{ totalAmount | currency:'USD' }}</td>
         </tr>
      </tbody>
   </table>
   
   <button (click)="clearCart()" *ngIf="cartCount > 0" style="float:right;" class="btn btn-md btn-danger">
     <span class="glyphicon glyphicon-trash"></span> Clear Cart 
   </button>

   <!--
      handle template
      uib-popover-template="'~/../app/js/cart/guest-checkout.html'" 
      popover-is-open="isOpen" 
      popover-placement="top"
      
      ? [(open)]="isOpen" 
    -->
   <button (click)="checkoutCart(false)" *ngIf="cartCount > 0 && !user.loggedin" 
   		   [ngbPopover]="popoverTemplate" 
           [placement]="'top'" 
           [disabled]="redirecting" (blur)="isOpen = false" 
           style="float:right;margin-right:10px" class="btn btn-md btn-info">
     <span class="glyphicon glyphicon-shopping-cart"></span> Checkout 
   </button>

   <button (click)="checkoutCart(false)" *ngIf="cartCount > 0 && user.loggedin" 
           [disabled]="redirecting" style="float:right;margin-right:10px" class="btn btn-md btn-warning">
     <span class="glyphicon glyphicon-shopping-cart"></span> Checkout 
   </button>

</div>
</app-block-ui-wrapper>
<div class="main container" *ngIf="!cartOn">
  <div class="text-center full-center">
    <h1><span style="font-size:3em" class="glyphicon glyphicon-remove-sign text-red"></span></h1>
    <h3><span>HTTP 400 - Bad Request</span></h3>
  </div>
</div>

<!-- Popover Template -->
<ng-template #popoverTemplate>
  <div class="panel-body">
    <div>
      <p>Not a member? <a class="pointMe" (click)="register()">Register</a> today</p>
    </div>
    <div>
      <p>Already registered? Login <a class="pointMe" (click)="login()">here</a></p>
    </div>
    <hr>
    <div class="text-center">
      <button (click)="checkoutCart(true)" class="btn btn-sm btn-warning">
        Proceed as guest
      </button>
    </div>
  </div>
</ng-template>